import AdminRoutes from '~pages/Admin/routes'
import ProjectsRoutes from './Projects/routes'
import PeopleRoutes from './People/routes'
import PreProjectsRoutes from './PreProjects/routes'
import FinanceRoutes from './Finance/routes'
import OrganizationRoutes from './Organizations/routes'
import ReferralRoutes from './Referral/routes'
import ValidationRoutes from './Validation/routes'
import ProjectRoutes from '~pages/Project/routes'
import LandsRoutes from './Lands/routes'
import TermsRoutes from './Terms/routes'
import CustomerPortalRoutes from './CustomerPortal/routes'
import ReportsRoutes from './Reports/routes'
import CommunicationRoutes from './Communication/routes'
import BillingRoutes from './Billing/routes'

const Index = () => import('~pages/Index.vue')
const NavBar = () => import('~components/navbar/NavBar.vue')

export default [
  {
    path: '/',
    components: {
      default: Index,
      navbar: NavBar
    },
    children: [
      ...AdminRoutes,
      ...ProjectsRoutes,
      ...PeopleRoutes,
      ...PreProjectsRoutes,
      ...FinanceRoutes,
      ...OrganizationRoutes,
      ...ValidationRoutes,
      ...ProjectRoutes,
      ...LandsRoutes,
      ...ReportsRoutes,
      ...CommunicationRoutes,
      ...BillingRoutes
    ]
  },
  {
    path: '/',
    components: {
      default: Index
    },
    children: [...ReferralRoutes, ...CustomerPortalRoutes, ...TermsRoutes]
  }
]
